import { Options } from "ky";
import { fetcher } from "../fetcher";
import { Pagination } from "../pagination";
import { RecommendItem } from "./type";

export async function getRecommendItems(options?: Options): Promise<Pagination<RecommendItem>> {
  return await fetcher.get('recommend-items', options).json();
}
